
if (iCreateObject.isSiteInICreateMode) {
	var toggleHtmlStructure = '<div class="toggleContent cf"><div class="ic-container-fluid">';

	if ($('.eventContentTool').length > 0) {
		toggleHtmlStructure += '<label for="chkHideCalendar" class="ic-checkbox-inline">';
		toggleHtmlStructure += '<input id="chkHideCalendar" type="checkbox" name="chkHideCalendar" />Hide Calendar</label>';
	}

	if ($('.newsCarousel').length > 0) {
		toggleHtmlStructure += '<label for="chkHideBlog" class="ic-checkbox-inline">';
		toggleHtmlStructure += '<input id="chkHideBlog" type="checkbox" name="chkHideBlog" />Hide Blog</label>';
	}

	toggleHtmlStructure += '<label for="chkHideEmergencyAlert" class="ic-checkbox-inline">';
	toggleHtmlStructure += '<input id="chkHideEmergencyAlert" type="checkbox" name="chkHideEmergencyAlert" />Hide Emergency Alert</label>';

	toggleHtmlStructure += '</div>';

	$('#quickLinksContainer').after(toggleHtmlStructure);
}

if ($('#TKInteriorHideAreasToggle #frmToggleContent').length <= 0) {
	var myForm = $('<form>');
	myForm.attr({
		'id': 'frmToggleContent',
		'action': '#'
	});

	if ($('.eventContentTool').length > 0) {
		myForm.append($('<input>').attr({
			'type': 'hidden',
			'id': 'hdnHideCalendar',
			'value': $('.eventContentTool').hasClass('hide') ? 'hide' : ''
		}));
	}

	if ($('.newsCarousel').length > 0) {
		myForm.append($('<input>').attr({
			'type': 'hidden',
			'id': 'hdnHideBlog',
			'value': $('.newsCarousel').hasClass('hide') ? 'hide' : ''
		}));
	}

	myForm.append($('<input>').attr({
		'type': 'hidden',
		'id': 'hdnHideEmergencyAlert',
		'value': ''
	}));
	myForm.append($('<input>').attr({
		'type': 'submit',
		'id': 'btnToggleContent',
		'name': 'btnToggleContent',
		'aria-label': 'Toggle Content'
	}).addClass('hideButton'));

	$('#TKInteriorHideAreasToggle').empty().append(myForm);
}

// bind checkbox with hidden fields
//Emergency Banner
if (($('#hdnHideEmergencyAlert').length > 0) && ($('#hdnHideEmergencyAlert').val() === 'hide')) {
	if ($('#chkHideEmergencyAlert').length > 0) {
		$('#chkHideEmergencyAlert').attr('checked', 'checked');
	}
}

//Events Content Tool
if ($('.eventContentTool').length > 0 && ($('#hdnHideCalendar').length > 0) && ($('#hdnHideCalendar').val() === 'hide')) {
	if ($('#chkHideCalendar').length > 0) {
		$('#chkHideCalendar').attr('checked', 'checked');
	}

	$('.eventContentTool').toggleClass('hide', true);
} else if ($('.eventContentTool').length > 0 && ($('#hdnHideCalendar').length > 0) && ($('#hdnHideCalendar').val() === '')) {
	$('.eventContentTool').toggleClass('hide', false);
}

//Blog
if ($('.newsCarousel').length > 0 && ($('#hdnHideBlog').length > 0) && ($('#hdnHideBlog').val() === 'hide')) {
	if ($('#chkHideBlog').length > 0) {
		$('#chkHideBlog').attr('checked', 'checked');
	}

	$('.newsCarousel').toggleClass('hide', true);
} else if ($('.newsCarousel').length > 0 && ($('#hdnHideBlog').length > 0) && ($('#hdnHideBlog').val() === '')) {
	$('.newsCarousel').toggleClass('hide', false);
}

// bind checkbox change event
//Emergency Banner
if ($('#chkHideEmergencyAlert').length > 0) {
	$('#chkHideEmergencyAlert').change(function () {
		$('#hdnHideEmergencyAlert').val($('#chkHideEmergencyAlert:checked').length > 0 ? 'hide' : '');

		if (iCreateObject.isSiteInICreateMode) {
			$('#TKInteriorHideAreasToggle').save();
		}
	});
}

//Calendar
if ($('.eventContentTool').length > 0 && $('#chkHideCalendar').length > 0) {
	$('#chkHideCalendar').change(function () {
		$('.eventContentTool').toggleClass('hide', $(this).is(':checked'));
		$('#hdnHideCalendar').val($('.eventContentTool').hasClass('hide') ? 'hide' : '');

		if (iCreateObject.isSiteInICreateMode) {
			$('#TKInteriorHideAreasToggle').save();
		}
	});
}
//Blog
if ($('.newsCarousel').length > 0 && $('#chkHideBlog').length > 0) {
	$('#chkHideBlog').change(function () {
		$('.newsCarousel').toggleClass('hide', $(this).is(':checked'));
		$('#hdnHideBlog').val($('.newsCarousel').hasClass('hide') ? 'hide' : '');

		if (iCreateObject.isSiteInICreateMode) {
			$('#TKInteriorHideAreasToggle').save();
		}
	});
}
